import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useMutation } from "@tanstack/react-query";
import z from "zod";

export interface GenerateStripeExpressSignInLinkRequest {
  returnUrl: string;
}

export function useGenerateStripeExpressSignInLink() {
  const worker = useDefinedWorker();

  return useMutation({
    mutationFn: async (data: GenerateStripeExpressSignInLinkRequest) => {
      return await post({
        url: `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${worker.userId}/generate-express-account-link`,
        data,
        responseSchema: z.string(),
      });
    },
  });
}
